export const listMenuAll = [
  {
    nameMenu: "Dashboard",
    pathnameMenu: "/dashboard",
    activePathMenubar: ["/dashboard", "/"],
  },
  {
    nameMenu: "Students",
    pathnameMenu: "/students",
    activePathMenubar: ["/students"],
  },
  {
    nameMenu: "Report/Record",
    pathnameMenu: "/report-record",
    activePathMenubar: ["/report-record"],
  },
  {
    nameMenu: "Activities",
    pathnameMenu: "/activities",
    activePathMenubar: ["/activities", "/activities/train-image-activities"],
  },
];
